import useSWR from 'swr'

import {
  standardRecipeTileFetcher,
  type StandardRecipeTileQueryInput,
  type StandardRecipeItem,
} from '@library/api-menu-experience'

export const recipeResourceOptions = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  revalidateIfStale: false,
  errorRetryCount: 2,
}

export const useRecipeTile = (
  input: StandardRecipeTileQueryInput,
  original: StandardRecipeItem,
  originalNumPortions: number,
) => {
  const valid = Boolean((input.menuId || input.menuUrn) && input.deliveryDate && input.numPortions)
  // Reuse matching menu/search data to avoid a separate fetch for each initial tile.
  // With revalidateIfStale disabled, SWR uses cached data or this fallback without refetching.
  const fallbackData =
    original.id === input.recipeId && originalNumPortions === input.numPortions
      ? original
      : undefined
  const resource = useSWR(
    valid ? ['menu-experience-recipe', 'tile', input] : null,
    async () => {
      const tile = await standardRecipeTileFetcher(input)
      if (!tile || tile.id !== input.recipeId) throw new Error('Invalid recipe tile response')

      return tile
    },
    {
      ...recipeResourceOptions,
      fallbackData,
    },
  )

  return {
    data: resource.data,
    error: resource.error,
    isLoading: resource.isLoading,
    isValidating: resource.isValidating,
    mutate: resource.mutate,
    tile: resource.data,
  }
}
